// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    profile: '/auth/profile',
  },
  
  // Admin Management
  admins: {
    list: '/admin',
    create: '/admin',
    get: (id) => `/admin/${id}`,
    update: (id) => `/admin/${id}`,
    delete: (id) => `/admin/${id}`,
    toggleStatus: (id) => `/admin/${id}/toggle-status`,
    stats: '/admin/stats',
  },
  
  // Organizations
  organizations: {
    list: '/organizations',
    create: '/organizations',
    createWithQR: '/organizations/with-qr',
    bulkCreate: '/organizations/bulk', // Add bulk endpoint
    get: (id) => `/organizations/${id}`,
    update: (id) => `/organizations/${id}`,
    delete: (id) => `/organizations/${id}`,
    generateQR: (id) => `/organizations/${id}/qr-code`,
    getQR: (id) => `/organizations/${id}/qr-code`,
    regenerateQR: (id) => `/organizations/${id}/qr-code/regenerate`,
    stats: '/organizations/stats',
  },
  
  // Cashiers
  cashiers: {
    list: '/cashiers',
    create: '/cashiers',
    get: (id) => `/cashiers/${id}`,
    update: (id) => `/cashiers/${id}`,
    delete: (id) => `/cashiers/${id}`,
    stats: '/cashiers/stats',
  },
  
  // QR Codes
  qrCodes: {
    list: '/qr-codes',
    create: '/qr-codes',
    get: (id) => `/qr-codes/${id}`,
    update: (id) => `/qr-codes/${id}`,
    delete: (id) => `/qr-codes/${id}`,
    stats: '/qr-codes/stats',
  },
  
  // Redemptions
  redemptions: {
    list: '/redemptions',
    create: '/redemptions',
    get: (id) => `/redemptions/${id}`,
    update: (id) => `/redemptions/${id}`,
    delete: (id) => `/redemptions/${id}`,
    stats: '/redemptions/stats',
  },
  
  // Scan Events (under /scan route)
  scanEvents: {
    list: '/scan/events',
    create: '/scan',
    get: (id) => `/scan/events/${id}`,
    update: (id) => `/scan/events/${id}`,
    delete: (id) => `/scan/events/${id}`,
    stats: '/scan/stats',
  },
  
  // Emails
  emails: {
    list: '/email',
    send: '/email/send',
    get: (id) => `/email/${id}`,
    retry: (id) => `/email/${id}/retry`,
    stats: '/email/stats',
  },
};

// API Headers
export const getApiHeaders = (token) => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${token}`,
});

// API Error Messages
export const API_ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'Unauthorized. Please login again.',
  FORBIDDEN: 'Access denied. You do not have permission to perform this action.',
  NOT_FOUND: 'Resource not found.',
  VALIDATION_ERROR: 'Validation error. Please check your input.',
  SERVER_ERROR: 'Server error. Please try again later.',
  TIMEOUT: 'Request timeout. Please try again.',
};

// API Timeout Configuration
export const API_TIMEOUT = 30000; // 30 seconds

// API Retry Configuration
export const API_RETRY_CONFIG = {
  retries: 3,
  retryDelay: 1000,
  retryCondition: (error) => {
    return error.response?.status >= 500 || error.code === 'ECONNABORTED';
  },
};
